import {
  PartialSearchFilters,
  SearchOptions,
  SearchRequest,
  SearchResults,
} from 'store/search/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

export const OPEN_CLOUD_ASSETS = createAction('@SEARCH/OPEN_CLOUD_ASSETS')();
export const CLOSE_CLOUD_ASSETS = createAction('@SEARCH/CLOSE_CLOUD_ASSETS')();

export const SET_LIMIT = createAction('@SEARCH/SET_LIMIT')<number>();

export const SET_OFFSET = createAction('@SEARCH/SET_OFFSET')<number>();

export const SET_FILTER =
  createAction('@SEARCH/SET_FILTER')<PartialSearchFilters>();

export const SET_SORT = createAction('@SEARCH/SET_SORT')<string>();

export const REFETCH_SEARCH = createAction('@SEARCH/REFETCH')();

export const TOGGLE_CHOSEN_SEARCH_ASSET = createAction(
  '@SEARCH/TOGGLE_CHOSEN_ASSET',
)<string>();

export const CLEAR_CHOSEN_SEARCH_ASSETS = createAction(
  '@SEARCH/CLEAR_CHOSEN_ASSETS',
)();

export const CACHE_LAST_GOOD_REQUEST = createAction(
  '@SEARCH/CACHE_LAST_GOOD_REQUEST',
)<SearchRequest>();

export const CLEAR_CACHED_REQUEST = createAction(
  '@SEARCH/CLEAR_CACHED_REQUEST',
)();
export const SET_CLOUD_ASSET_OPTIONS = createAction(
  '@SEARCH/SET_CLOUD_ASSET_OPTIONS',
)<SearchOptions>();

export const UNSET_CLOUD_ASSETS = createAction('@SEARCH/UNSET_CLOUD_ASSETS')();

export const SEARCH = createAsyncAction(
  '@SEARCH/REQUEST',
  '@SEARCH/RESPONSE',
  '@SEARCH/FAILURE',
)<SearchRequest, SearchResults, undefined>();
